<template>
  <PageLayout>
    <div class="pl-2">
      <PageHeader
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${
              this.$route.params.isReissue
                ? this.$t(`apply.button.reissue`)
                : this.$t(
                    `Common.title.${this.$route.params.typeName?.toString()}`
                  )
            }`,
        },
      ]"
    />
    </div>
    
    <StepsLayout
      :title="`${$t('Common.title.homeTitle')}`"
      :steps="steps"
      v-model="currentStep"
    >
      <div class="pa-6">
        <StepFirst
          :formData="data"
          v-show="currentStep === 0"
          ref="onNext0"
          @next="onNext"
          @previous="$router.back()"
        />
        <StepSecond
          :formData="data"
          v-if="currentStep === 1"
          ref="onNext1"
          @next="onNext"
          @previous="currentStep = 0"
        />
        <StepThird
          :formData="data"
          v-if="currentStep === 2"
          ref="onNext2"
          @next="onNext"
          @previous="currentStep = 1"
        />
        <StepFour
          :formData="data"
          v-if="currentStep === 3"
          ref="onNext3"
          @next="onNext"
          @previous="currentStep = 2"
        />
      </div>
    </StepsLayout>
    <template slot="actions">
      <m-button
        type="primary"
        ghost
        size="large"
        @click="$refs[`onNext${currentStep}`].onPrevious()"
        class="mr-4"
        >{{ this.$t('Common.action.back') }}</m-button
      >
      <m-button
        type="primary"
        size="large"
        @click="$refs[`onNext${currentStep}`].onNext()"
        >{{ this.$t('Common.action.nextStep') }}</m-button
      >
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import StepsLayout from '@/components/Layout/web/StepsLayout.vue';
import StepFirst from '../business/StepFirst.vue';
import StepSecond from '../business/StepSecond.vue';
import StepThird from '../business/StepThird.vue';
import StepFour from '../business/StepFour.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';

export default {
  name: 'Home',
  components: {
    PageLayout,
    StepsLayout,
    StepFirst,
    StepSecond,
    StepThird,
    StepFour,
    PageHeader
  },
  data() {
    return {
      currentStep: 0,
      data: null,
    };
  },
  computed: {
    steps() {
      return [
        this.$t(`apply.title.baseInfo`),
        this.$t(`apply.title.venueData`),
        this.$t(`apply.title.infoUpload`),
        this.$t(`apply.title.checkData`),
      ];
    },
  },
  methods: {
    onNext(form) {
      this.data = form;
      this.currentStep++;
    },
  },
  async created() {
    console.log('====1', this.$route.params);
  },
};
</script>
